import React from 'react';
import { Route } from 'react-router-dom';
import ManishProfile from '../Profiles/ManishProfile';
import CharlesPrinceProfile from '../Profiles/CharlesPrinceProfile';
import BarryHasenkopfProfile from '../Profiles/BarryHasenkopfProfile';
import KirbyGodseyProfile from '../Profiles/KirbyGodseyProfile';
import DarrelColsonProfile from '../Profiles/DarrelColsonProfile';
import LincolnMehtaProfile from '../Profiles/LincolnMehtaProfile';

export const profileRoutes = [
  <Route key="manish" path="/profile/manish" element={<ManishProfile />} />,
  <Route key="charles-prince" path="/profile/charles-prince" element={<CharlesPrinceProfile />} />,
  <Route key="barry-hasenkopf" path="/profile/barry-hasenkopf" element={<BarryHasenkopfProfile />} />,
  <Route key="kirby-godsey" path="/profile/kirby-godsey" element={<KirbyGodseyProfile />} />,
  <Route key="darrel-colson" path="/profile/darrel-colson" element={<DarrelColsonProfile />} />,
  <Route key="lincoln-mehta" path="/profile/lincoln-mehta" element={<LincolnMehtaProfile />} />,
];
